import _ from 'lodash';
import Box from '@mui/material/Box';
import PieChartSimple from './PieChartSimple';
import { CHART_TYPE } from './constants';
import PieChartLabel from './PieChartLabel';

// data:
// [
//   { name: 'Group A', value: 100 }
// ]

const COLORS = ['#5e9ff8', '#DEA7DF', '#e2a429', '#B4B5E0', '#8DC77B', '#E2CF45', '#4ecde6', '#e9a0a2', '#A9B7C4', '#cde6c5'];


const PieChart = ({ chartType, chartData }) => {

  const pieChartData = chartData && Object.entries(chartData).sort((a, b) => b[1] - a[1]).slice(0, 10).map((el) => {
    return {
      "name": el[0],
      "value": parseInt(el[1])
    }
  })

  // const dataWithFloatValues = data.map(item => ({ ...item, value: parseFloat(item.value) }));

  // // 計算總值
  // const sumOfValues = dataWithFloatValues.reduce((sum, item) => sum + item.value, 0);

  // // 計算百分比
  // const dataWithPercentages = dataWithFloatValues.map(item => ({ ...item, percentage: (item.value / sumOfValues) * 100 }));

  // // 確保百分比總和為 100%
  // const totalPercentage = dataWithPercentages.reduce((sum, item) => sum + item.percentage, 0);

  // const pieChartData = dataWithPercentages.map(item => ({ ...item, value: Math.round((item.percentage / totalPercentage) * 100) }));

  // 計算"其他"項目的值
  // const otherValue = 1000 - sumOfValues;
  // const newData = [...data, { name: '其他', value: otherValue }];

  // console.log('data', data);
  // console.log('pieChartData', pieChartData);

  return (
    <>
      {
        chartType === CHART_TYPE.CUSTOM_LABEL_PIE_CHART &&
        <Box>
          <PieChartLabel
            chartData={pieChartData}
            colors={COLORS}
            label={"name"}
          />
          <PieChartSimple
            chartData={pieChartData}
            colors={COLORS}
          />
        </Box>
      }
    </>
  );
};

export default PieChart;